// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4f720283bf--wrapper--APnB0","label":"_4f720283bf--label--k_5Nh","btns":"_4f720283bf--btns--eJzc2","mobile":"_4f720283bf--mobile--SGDX0"};